import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneBanner, updateBanner } from 'slice/bannerSlice';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';

const UpdateBanner = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, data } = useSelector((state) => state.banner);
    const [formData, setFormData] = useState({
        heading: '',
        image: null,
        is_active: 1
    });

    useEffect(() => {
        dispatch(getOneBanner(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (data) {
            setFormData({
                heading: data.heading || '',
                is_active: data.is_active ?? 1,
                image: null
            });
        }
    }, [data]);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? e.target.files[0] : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const payloadData = {
                heading: formData.heading,
                is_active: formData.is_active,
                imageFile: formData.image || null
            };

            dispatch(updateBanner({ id: id, data: payloadData }))
            toast.success('Banner updated successfully!');
            navigate('/banner')

        } catch (error) {
            console.error('There was a problem updating the banner:', error.message);
            toast.error('Failed to update banner');
        }
    };

    return (
        <div className="container-fluid px-4 py-4">
            <div className="card shadow border-0">
                <div className="card-header bg-primary text-white py-3">
                    <h5 className="mb-0">Update Banner</h5>
                </div>
                <div className="card-body p-4">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bannerHeading" className="adminlables">Banner Heading</label>
                                <input
                                    type="text"
                                    id="bannerHeading"
                                    name="heading"
                                    value={formData.heading}
                                    className="form-control"
                                    placeholder="Update heading"
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="is_active" className="adminlables">Status</label>
                                <select id="is_active" name="is_active" value={formData.is_active} className="form-control" onChange={handleChange}>
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </select>
                            </div>
                            <div className="col-md-6 mb-4">
                                <label htmlFor="bannerImage" className="adminlables">Banner Image (Leave blank to keep current)</label>
                                <input
                                    type="file"
                                    id="bannerImage"
                                    name="image"
                                    accept="image/*"
                                    className="form-control btn-block filebg"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="col-md-6 mb-4">
                                <p className="adminlables mb-1">Current Image</p>
                                <div>
                                    {data?.image ? (
                                        <img
                                            src={`${process.env.REACT_APP_BACKEND}${data.image}`}
                                            alt={data.heading}
                                            className="banner-thumb"
                                            onError={(e) => { e.target.style.display = 'none'; }}
                                        />
                                    ) : (
                                        <p className="text-muted mb-0">No image</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="d-flex justify-content-end gap-3 mt-4">
                            <button type="button" className="btn btn-light px-4" onClick={() => navigate('/banner')}>
                                Cancel
                            </button>
                            <button type="submit" className="btn btn-primary px-5" disabled={loading}>
                                {loading ? 'Updating...' : 'Update Banner'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default UpdateBanner;
